'use strict';

var $ = require('jquery');
var searchsuggest = require('./searchsuggest').default;
var optiExperiment = require('../components/optimizelyExperimentation');

/**
 * @private
 * @function
 * @description
 */
var searchinputfield = {
    /**
     * @function
     * @description initializes the label move feature for input fields and select boxes
     */
    init: function () {
        var $body = $('body');
        var $header = $('.header');
        var $headerSearchTrigger = $('.header-search-trigger');
        var $headerSearchInput = $('.header-search-input, .header-mobile-search-input');
        var $searchContainer = $('.header-search');
        var $searchForm = $('form[name="simpleSearch"]');

        $headerSearchTrigger.on('click', function (e) {
            e.preventDefault();

            // if it's the second click of the user, then let the search field close
            if (!$header.hasClass('active-search')) {
                $header.addClass('active-search');
                $searchContainer.fadeIn();
                $('#q').focus();
            } else {
                $header.removeClass('active-search');
                $searchContainer.fadeOut();
            }
        });

        if (!$('.site-container .new-header').length > 0) {
            $(document).on('click', function (e) {
                var target = e.target;
                if ($header.hasClass('active-search')) {
                    if (
                        !$.contains($searchForm[0], target) &&
                        !$.contains($headerSearchTrigger[0], target) &&
                        !$(e.target).hasClass('header-search-trigger')
                    ) {
                        $header.toggleClass('active-search');
                        $searchContainer.fadeOut();
                    }
                }
                $('.search-suggestions').fadeOut();
                $body.trigger('suggestions:hide');
            });
        } else {
            $(document).on('touchmove', function (e) {
                e.preventDefault();
                document.activeElement.blur();
            });
        }

        $('body').on('click', '.close-search', function () {
            $('.header-navigation-mobile').removeClass('active');
            $('.search-suggestions').fadeOut();
            $headerSearchInput.val('');
            $body.trigger('suggestions:hide');
        });

        $('body').on(
            'click',
            '.header-navigation-mobile, .header-navigation-desktop, .header-navigation-tablet',
            function () {
                $('.header-navigation-mobile').removeClass('active');
                $('.header-navigation-tablet').removeClass('active');
                $('.header-navigation-desktop').removeClass('active');
                $('.search-suggestions').fadeOut();
                $headerSearchInput.val('');
                $body.trigger('suggestions:hide');
            }
        );

        $searchForm.submit(function (event) {
            var $searchInput = $(this).find('input[name="q"]');
            var placeHolder = $searchInput.attr('placeholder');
            var value = $searchInput.val();

            if (value === '' || value === placeHolder || value.replace(/\s/g, '').length === 0) {
                event.preventDefault();
            }
        });

        $headerSearchInput
            .on('focus', function () {
                $searchForm.addClass('header-search-focused');
            })
            .on('blur', function () {
                $searchForm.removeClass('header-search-focused');
            })
            .blur();

        $('body').on('click', '.header-search-input', function () {
            optiExperiment.trackEvent('search_bar_click');
        });

        /**
         * initialize search suggestions
         * */
        searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);
    },
    faqInit: function () {
        var $faqSearchInput = $('.faq-search-input, .faq-mobile-search-input');
        var $faqSearchContainer = $('.faq-search');
        var $faqSearchForm = $('form[name="faqSimpleSearch"]');

        $(document).on('click', function (e) {
            $('.faq-search-suggestions').fadeOut();
        });

        $faqSearchForm.submit(function (event) {
            var $faqSearchInputField = $(this).find('input[name="q"]');
            var placeHolder = $faqSearchInputField.attr('placeholder');
            var value = $faqSearchInputField.val();

            if (value === '' || value === placeHolder || value.replace(/\s/g, '').length === 0) {
                event.preventDefault();
            }
        });

        $faqSearchInput
            .on('focus', function () {
                $faqSearchForm.addClass('faq-search-focused');
            })
            .on('blur', function () {
                $faqSearchForm.removeClass('faq-search-focused');
            })
            .blur();

        /**
         * initialize faq search suggestions
         * */
        searchsuggest.faqInit($faqSearchContainer, Resources.FAQ_SEARCH);
    }
};

module.exports = searchinputfield;
